import { useMemo, useState } from 'react';
import { debounce } from 'lodash';

import useLatest from 'utils/hooks/useLatest';
import useUpdateEffect from 'utils/hooks/useUpdateEffect';

const useDebouncedValue = (currentValue, debounceBy = 300) => {
  const [value, setValue] = useState(currentValue);

  const updateValue = useMemo(() => debounce(setValue, debounceBy), [debounceBy]);
  const updateValueRef = useLatest(updateValue);

  useUpdateEffect(() => updateValueRef.current(currentValue), [currentValue]);

  return value;
};

export default useDebouncedValue;
